import React, { useState, useEffect, useContext } from "react";
import { CrudReceptions } from "../../Components/Cruds/CrudReceptions";
import { CrudQualitysReceptions } from "../../Components/Cruds/CrudQualitysReceptions";
import { CrudDocManagaments } from "../../Components/Cruds/CrudDocManagements";
import { getUserPermissionsByUserEmail } from "../../api/usersModule/getters";
import { NotFoundPage } from "../NotFoundPage/NotFoundPage";
import { LoadingPage } from "../LoadingPage/LoadingPage";
import { useLocation, Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../../utils/Contexts/UserContext";

const moduleName = "Indicadores";
export const ReceptionsPage = () => {
  const [userPermissions, setUserPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [change, setChange] = useState(1);
  const location = useLocation();
  const navigate = useNavigate();
  const user = useUserContext();

  const getPermissions = async () => {
    setLoading(true);

    let permissions = {
      Consultar: false,
      Crear: false,
      Editar: false,
      Eliminar: false,
    };

    try {
      permissions = await getUserPermissionsByUserEmail(
        user.attributes["email"],
        user.attributes["custom:project"],
        moduleName
      );
      try {
        permissions["Consultar"]
          ? setUserPermissions(permissions)
          : setUserPermissions([]);
      } catch (error) {
        permissions["Consultar"] = false;
      }
      setUserPermissions(permissions);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleNavigateToSkus = () => {
    navigate(`/skus`, { state: location.state });
  };

  useEffect(() => {
    getPermissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {userPermissions && userPermissions["Consultar"] ? (
        <div
          style={{
            flex: "1 1 auto",
            display: "flex",
            flexFlow: "column",
            height: "100vh",
            overflowY: "auto",
          }}
        >
          {location.state && location.state.codeSap !== "" ? (
            <div>
              <Button className="linkButton" onClick={handleNavigateToSkus}>
                &#8592; Volver
              </Button>
            </div>
          ) : null}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100vh",
              overflowY: "auto",
            }}
          >
            <div style={{ padding: "20px 5%", flex: "1" }}>
              <CrudReceptions
                userName={user.attributes.family_name}
                permissions={userPermissions}
                project={user.attributes["custom:project"]}
                codeSap={location.state ? location.state.codeSap : ""}
                nit={
                  location.state
                    ? location.state.nit || location.state.project
                    : ""
                }
                setChange={setChange}
                change={change}
              />
            </div>
            <div style={{ padding: "20px 5%", flex: "1" }}>
              <CrudQualitysReceptions
                userName={user.attributes.family_name}
                permissions={userPermissions}
                project={user.attributes["custom:project"]}
                codeSap={location.state ? location.state.codeSap : ""}
                nit={
                  location.state
                    ? location.state.nit || location.state.project
                    : ""
                }
                change={change}
              />
            </div>
            <div style={{ padding: "20px 5%", flex: "1" }}>
              <CrudDocManagaments
                userName={user.attributes.family_name}
                permissions={userPermissions}
                project={user.attributes["custom:project"]}
                codeSap={location.state ? location.state.codeSap : ""}
              />
            </div>
          </div>
        </div>
      ) : loading ? (
        <LoadingPage />
      ) : (
        <NotFoundPage />
      )}
    </>
  );
};
